import { rem } from 'polished';
import styled from 'styled-components/macro';

import { IStyledWrapperProps } from './Drawer.types';

export const StyledCloseButton = styled.button`
  position: absolute;
  top: ${rem('18px')};
  right: ${rem('16px')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  background-color: transparent;
  border: none;
  appearance: none;
  cursor: pointer;

  svg {
    display: block;
    width: ${rem('14px')};
    height: auto;
  }
`;

export const StyledContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;

export const StyledTitle = styled.span`
  display: flex;
  margin-bottom: ${rem('40px')};
  padding: ${rem('4px')} 0 ${rem('16px')} 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: 600;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
`;

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: column;
  padding: ${rem('16px')};
  background-color: ${({ theme }) => theme.colors.main};
`;
